import React, { useContext } from "react";
import { Drawer, Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import MobileUserSettingsPanel from "./MobileUserSettingsPanel";
import { UserContext } from "../../../context/UserContext";
import { getRoleLabelWithFacility } from "../../../helpers/getRoleLabel";

const { Option } = Select;

const ReceptionistMobileDrawer = ({
  open,
  setOpen,
  sideContent,
  onRoleChange,
  selectedRole,
  selectedFacility,
  hideRoleDropdown,
}) => {
  const { userDetails } = useContext(UserContext);
  const showRoleSelect =
    !hideRoleDropdown && userDetails?.activeOrg?.roles?.length > 1;

  return (
    <Drawer
      placement="left"
      closable={false}
      onClose={() => setOpen(false)}
      open={open}
      width="100%"
      rootClassName="reception-mobile-drawer-fullscreen"
      styles={{
        body: {
          padding: "16px",
          paddingBottom: "calc(16px + env(safe-area-inset-bottom, 0px))",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
      }}
    >
      <div className="reception-mobile-drawer-header">
        {showRoleSelect ? (
          <Select
            className="reception-mobile-drawer-select"
            value={`${selectedRole}_${selectedFacility}`}
            onChange={(value) => {
              onRoleChange(value);
              setOpen(false);
            }}
          >
            {userDetails?.activeOrg?.roles?.map(
              (role) =>
                role?.role !== "Partner" && (
                  <Option
                    key={`${role?.role}_${role?.facility_id}`}
                    value={`${role?.role}_${role?.facility_id}`}
                  >
                    {getRoleLabelWithFacility(role)}
                  </Option>
                )
            )}
          </Select>
        ) : (
          <span className="reception-mobile-drawer-header-spacer" />
        )}
        <button
          type="button"
          className="reception-mobile-drawer-close"
          onClick={() => setOpen(false)}
          aria-label="Close menu"
        >
          <CloseOutlined />
        </button>
      </div>

      <div className="reception-mobile-drawer-menu">
        {sideContent && React.cloneElement(sideContent, { collapsed: false })}
      </div>

      <div className="reception-mobile-drawer-footer">
        <MobileUserSettingsPanel onNavigate={() => setOpen(false)} />
      </div>
    </Drawer>
  );
};

export default ReceptionistMobileDrawer;
